<template>
	<svg
		fill="currentColor"
		:width="size"
		:height="size"
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		:style="{ verticalAlign: 'middle' }"
		v-bind="$attrs"
	>
		<title>knife</title>
		<path
			d="M14.602 8.359l-0.038 0.035c-1.901-3.271-4.319-6.121-8.149-7.88-1.343-0.617-2.362 0.405-2.901 1.604-2.115 4.712 5.305-0.097 9.173 7.971l-0.015 0.014c-0.286 2.044-3.088 4.117-5.614 4.197 4.852 11.568 16.029 19.916 23.853 14.892-10.284-3.519-12.077-13.181-16.308-20.832z"
		></path>
	</svg>
</template>

<script>
export default {
	name: "KnifeIcon",
	props: {
		size: {
			type: [String, Number],
			default: 24,
		},
	},
}
</script>
